import axios from 'axios';
import { useEffect, useState } from 'react';
import Loader from 'react-loader-spinner';
import { useParams } from 'react-router';
import Error from '../Error/Error';
import NotFound from '../Error/NotFound';
import './GameDetail.scss';
import { url, token } from '../../utils/Config/config';
import { NavLink } from 'react-router-dom';
import 'swiper/swiper.scss';
import { SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import GameCard from '../../components/Card/GameCard';
import Carousel from '../../components/Carousel/Carousel';

const GameDetail = () => {
    const [game, setGame] = useState([]);
    const [related, setRelated] = useState([]);
    const { slug } = useParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        const getGame = async () => {
            setLoading(true);
            try {
                let response = await axios.get(`${url}/games/${slug}?key=${token}`);
                setGame(response.data);
                console.log(response.data);
                setLoading(false);
            } catch(e) {
                if(e.response.status === 404) {
                    setNotFound(true);
                    console.log(e.response);
                } else {
                    setError(true);
                    console.log(e.message);
                }
            }
        }
        getGame();

        const getRelatedGame = async () => {
            setLoading(true);
            try {
                let response = await axios.get(`${url}/games/${slug}/game-series?key=${token}`);
                setRelated(response.data.results);
                setLoading(false);
            } catch(e) {
                if(e.response.status === 404) {
                    setNotFound(true);
                    console.log(e.response);
                } else {
                    setError(true);
                    console.log(e.message);
                }
            }
        }
        getRelatedGame();
        
    }, [ slug ]);

    if (notFound) {
        return(<NotFound/>);
    } else if (error) {
        return(<Error />)
    } else {
        return (
            <div className="GameDetail">
            {loading ? 
                <Loader
                    className="loader"
                    type="ThreeDots"
                    color="#dc3545"
                    height={60}
                    width={60}
                />
                :
                <div>
                    <div className="container-fluid mt-5"
                        style={{
                            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${(game.background_image_additional)})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                    }}>
                        <div className="row mx-md-5 px-5 py-5">
                            <div className="col-md-4">
                                <img className="img-fluid rounded" src={game.background_image} alt={game.name} />
                            </div>
                            <div className="col-md-8 my-3 text-white">
                                <h1>{game.name}</h1>
                                <p><small>Average playtime {game.playtime} hours</small></p>
                                <p className="lead">
                                    <i className="fas fa-star text-warning me-2" />
                                    {game.rating}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-between my-5 mx-5">
                            <div className="col-md-4 col-lg-6">
                                <div className="ratio ratio-16x9">
                                    <iframe
                                        style={{ backgroundImage: `url(${(game?.preview)})` }}
                                        className="rounded"
                                        src={game?.clip?.clip}
                                        title={game.name}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-6">
                                <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active" id="pills-about-tab" data-bs-toggle="pill" data-bs-target="#pills-about" type="button" role="tab" aria-controls="pills-about" aria-selected="true">About</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">System Requirements</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Where to buy</button>
                                    </li>
                                </ul>
                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="pills-about" role="tabpanel" aria-labelledby="pills-about-tab">
                                        <div className="row mb-3">
                                            <div className="col">
                                                <h5>Description</h5>
                                                {game.description_raw}
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col">
                                                <h5><small>Platforms</small></h5>
                                                <p>
                                                    {game?.parent_platforms?.map((platform, index) => {
                                                        return(
                                                            <span key={index}>{ (index ? ', ' : '') + platform.platform.name}</span>
                                                        );
                                                    })}
                                                </p>
                                            </div>
                                            <div className="col">
                                                <h5><small>Genre</small></h5>
                                                <p>
                                                    {game?.genres?.map((genre, index) => {
                                                        return(
                                                            <span key={index}>{ (index ? ', ' : '') + genre.name}</span>
                                                        );
                                                    })}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col">
                                                <h5><small>Release Date</small></h5>
                                                <p>{game.released}</p>
                                            </div>
                                            <div className="col">
                                                <h5><small>Developer</small></h5>
                                                <p>
                                                    {game?.developers?.map((developer, index) => {
                                                        return(
                                                            <span key={index}>{ (index ? ', ' : '') + developer.name}</span>
                                                        );
                                                    })}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col">
                                                <h5><small>Publishers</small></h5>
                                                <p>
                                                    {game?.publishers?.map(publisher => {
                                                        return(
                                                            <span key={publisher.id}>{publisher.name}</span>
                                                        );
                                                    })}
                                                </p>
                                            </div>
                                            <div className="col">
                                                <h5><small>Age Rating</small></h5>
                                                {game?.esrb_rating?.name ?? null}
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col">
                                                <h5><small>Websites</small></h5>
                                                <a className="card-link" href={game.website}>{game.website}</a>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col">
                                                <h5><small>Tags</small></h5>
                                                <p>
                                                    {game?.tags?.map((tag, index) => {
                                                        return(
                                                            <span className="badge bg-dark me-1" key={index}>{tag.name}</span>
                                                        );
                                                    })}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                        <div className="row">
                                            <div className="col">
                                                <h5>Description</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                                        <div className="row">
                                            <div className="col">
                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <Carousel 
                            carouselTitle="Related Games"
                            content={related.map((relatedGame, index) => {
                                return(
                                    <SwiperSlide key={index}>
                                        <NavLink className="card-link" to={`/games/${relatedGame.slug}`}>
                                            <GameCard 
                                                thumbnail={relatedGame.background_image}
                                                title={relatedGame.name}
                                                rating={relatedGame.rating}
                                            />
                                        </NavLink>
                                    </SwiperSlide>
                                );
                            })}
                        />
                    </div>
                </div>
            }
            </div>
        );
    }
};

export default GameDetail;
